(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crm-anfrage"] && !Shopify.designMode) return;
  try {
    
  if (!window.customElements.get('crm-anfrage')) {
    // Wie im CRM: Honigtopf gefüllt oder schneller abgeschickt = Spam, wird still verworfen
    const MIN_FILL_MS = 2500;
    // Merkt sich über Shopifys Weiterleitung hinweg, ob das CRM die Anfrage hat
    const PENDING_KEY = 'crm-anfrage-mail';

    class CrmAnfrage extends HTMLElement {
      connectedCallback() {
        if (this.form) return;
        this.form = this.querySelector('form.crm-anfrage__form');
        if (!this.form) return;
        this.mail = this.querySelector('form.crm-anfrage__mail');
        this.openedAt = Date.now();
        this.form.addEventListener('change', () => this.update());
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.update();
        this.setBusy(false);
        this.afterMail();
      }

      // Zurück von Shopifys Kontaktformular: Danke zeigen – bei einem Fehler dort den Hinweis, außer das CRM hat die Anfrage schon
      afterMail() {
        let pending = null;
        try {
          pending = JSON.parse(window.sessionStorage.getItem(PENDING_KEY) || 'null');
          window.sessionStorage.removeItem(PENDING_KEY);
        } catch (error) {
          pending = null;
        }
        const posted = Boolean(this.querySelector('[data-mail-posted]')) || new URLSearchParams(window.location.search).get('contact_posted') === 'true';
        if (posted) {
          this.showSuccess();
        } else if (pending && this.querySelector('[data-mail-error]')) {
          if (pending.crm === 'ok') this.showSuccess();
          else this.showError(this.dataset.msgFailed);
        }
      }

      get intent() {
        const checked = this.form.querySelector('input[name="intent"]:checked');
        return checked ? checked.value : '';
      }

      field(name) {
        return this.form.elements.namedItem(name);
      }

      value(name) {
        const element = this.field(name);
        return element && !element.disabled ? String(element.value || '').trim() : '';
      }

      update() {
        const intent = this.intent;
        const delivery = Boolean(this.field('deliveryDiffers') && this.field('deliveryDiffers').checked);
        const country = this.field('country') ? this.field('country').value : '';
        this.querySelector('[data-fields]').hidden = !intent;

        this.querySelectorAll('[data-show]').forEach((element) => {
          let visible = intent !== '' && element.dataset.show.split(' ').includes(intent);
          if (visible && element.hasAttribute('data-delivery')) visible = delivery;
          element.hidden = !visible;
          element.querySelectorAll('input, select, textarea').forEach((input) => {
            input.disabled = !visible;
          });
        });

        this.querySelectorAll('[data-required]').forEach((input) => {
          input.required = input.dataset.required.split(' ').includes(intent);
        });

        const vat = this.field('vatId');
        if (vat) {
          const otherEu = (this.dataset.eu || '').split(',').includes(country);
          vat.required = intent === 'account' && otherEu;
          this.querySelector('[data-vat-label]').textContent = country === 'CH' || country === 'LI' ? 'UID-Nummer' : 'USt-IdNr.';
          this.querySelector('[data-vat-hint]').hidden = !vat.required;
        }

        this.querySelectorAll('[data-mark-for]').forEach((mark) => {
          const input = this.field(mark.dataset.markFor);
          mark.textContent = input && input.required ? ' *' : ' (optional)';
        });

        this.querySelectorAll('[data-legend]').forEach((legend) => {
          const key = intent === 'account' ? 'legendAccount' : intent === 'sample' ? 'legendSample' : 'legendOther';
          legend.textContent = legend.dataset[key] || legend.textContent;
        });
      }

      setBusy(busy) {
        this.busy = busy;
        const button = this.form.querySelector('[type="submit"]');
        if (!button) return;
        button.disabled = busy;
        button.setAttribute('aria-busy', busy ? 'true' : 'false');
      }

      showError(text) {
        const box = this.querySelector('[data-status]');
        box.querySelector('[data-message]').textContent = text;
        box.hidden = !text;
        if (text) box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      showSuccess() {
        this.form.hidden = true;
        const success = this.querySelector('[data-success]');
        success.hidden = false;
        success.focus();
        success.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      }

      async submit(event) {
        event.preventDefault();
        if (this.busy) return;
        if (!this.form.checkValidity()) {
          this.form.reportValidity();
          return;
        }

        const body = this.payload();
        this.setBusy(true);
        this.showError('');

        // 1. Ins CRM
        let crm = 'failed';
        try {
          const response = await this.post(body);
          if (response.ok) {
            crm = 'ok';
          } else {
            let detail = '';
            try {
              detail = (await response.json()).detail || '';
            } catch (error) {
              detail = '';
            }
            if (response.status === 400 && detail) {
              this.showError(detail);
              this.setBusy(false);
              return;
            }
            if (response.status === 429) crm = 'busy';
          }
        } catch (error) {
          crm = 'failed';
        }

        // Spam verwirft das CRM still – dann geht auch keine Mail raus
        if (body.website || body.elapsedMs < MIN_FILL_MS) {
          this.showSuccess();
          this.setBusy(false);
          return;
        }

        // 2. Kopie an die Shop-Adresse über Shopifys Kontaktformular – die Seite lädt danach neu
        const sent = await this.sendMail(body, crm);
        if (!sent) {
          if (crm === 'ok') this.showSuccess();
          else this.showError(crm === 'busy' ? this.dataset.msgBusy : this.dataset.msgFailed);
          this.setBusy(false);
        }
      }

      payload() {
        const intent = this.intent;
        const delivery = intent === 'account' && Boolean(this.field('deliveryDiffers') && this.field('deliveryDiffers').checked);
        return {
          intent,
          company: this.value('company'),
          legalName: this.value('legalName'),
          businessType: this.value('businessType'),
          firstName: this.value('firstName'),
          lastName: this.value('lastName'),
          email: this.value('email'),
          phone: this.value('phone'),
          country: this.value('country'),
          street: this.value('street'),
          postalCode: this.value('postalCode'),
          city: this.value('city'),
          deliveryDiffers: delivery,
          deliveryStreet: delivery ? this.value('deliveryStreet') : '',
          deliveryPostalCode: delivery ? this.value('deliveryPostalCode') : '',
          deliveryCity: delivery ? this.value('deliveryCity') : '',
          vatId: this.value('vatId'),
          invoiceEmail: this.value('invoiceEmail'),
          message: this.value('message'),
          page: window.location.pathname,
          website: this.value('crm_extra'),
          elapsedMs: Date.now() - this.openedAt,
        };
      }

      post(body) {
        const controller = typeof AbortController === 'function' ? new AbortController() : null;
        const timer = controller ? window.setTimeout(() => controller.abort(), 15000) : 0;
        return fetch(this.dataset.endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
          signal: controller ? controller.signal : undefined,
        }).finally(() => window.clearTimeout(timer));
      }

      // Shopify stellt jede Einsendung des Kontaktformulars an die Absenderadresse des Shops zu (info@) – Spam-Schutz wie von Shopify
      // für per Skript gefüllte Formulare vorgesehen (Shopify.captcha.protect, danach form.submit)
      sendMail(body, crm) {
        const mail = this.mail;
        if (!mail) return Promise.resolve(false);
        const set = (name, value) => {
          const input = mail.elements.namedItem(`contact[${name}]`);
          if (input) input.value = value || '';
        };
        set('email', body.email);
        set('name', `${body.firstName} ${body.lastName}`.trim());
        set('phone', body.phone);
        set('body', this.summary(body, crm));
        try {
          window.sessionStorage.setItem(PENDING_KEY, JSON.stringify({ crm }));
        } catch (error) {
          // ohne sessionStorage zeigt contact_posted=true trotzdem das Danke
        }

        return new Promise((resolve) => {
          let sent = false;
          const send = () => {
            if (sent) return;
            sent = true;
            // mail.submit, nicht HTMLFormElement.prototype.submit: protect ersetzt submit an diesem Formular und holt dabei das
            // Prüfzeichen (h-captcha-response)
            mail.submit();
            resolve(true);
          };
          const captcha = window.Shopify && window.Shopify.captcha;
          if (captcha && typeof captcha.protect === 'function') {
            try {
              captcha.protect(mail, send);
            } catch (error) {
              send();
              return;
            }
            // Lädt der Spam-Schutz nicht, trotzdem absenden – Shopify fragt dann selbst nach (Seite /challenge)
            window.setTimeout(send, 8000);
          } else {
            send();
          }
        });
      }

      // Text der Mail an info@: zuerst, ob das CRM die Anfrage hat, dann alle Angaben wie im Ticket
      summary(body, crm) {
        const status = {
          ok: 'Im CRM angekommen: Ticket an die Betreuung bzw. ans Team – bitte dort bearbeiten und aus dem Ticket antworten.',
          busy: 'NICHT im CRM angekommen (zu viele Anfragen von diesem Anschluss) – bitte prüfen und im CRM von Hand anlegen.',
          failed: 'NICHT im CRM angekommen (CRM nicht erreichbar) – bitte im CRM von Hand anlegen.',
        };
        const place = (street, zip, city) => [street, [zip, city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        const lines = [status[crm] || status.failed, ''];
        lines.push(`Anliegen: ${this.choiceTitle()}`);
        lines.push(`Betrieb: ${body.company}`);
        if (body.legalName && body.legalName.toLowerCase() !== body.company.toLowerCase()) lines.push(`Firmenname laut Handelsregister: ${body.legalName}`);
        if (body.businessType) lines.push(`Art des Betriebs: ${body.businessType}`);
        lines.push(`Ansprechpartner: ${body.firstName} ${body.lastName} · ${body.email}${body.phone ? ` · ${body.phone}` : ''}`);
        lines.push(`Land: ${this.optionText('country') || body.country}`);
        const address = place(body.street, body.postalCode, body.city);
        if (address) {
          const label = body.intent === 'account' ? 'Rechnungsadresse' : body.intent === 'sample' ? 'Lieferadresse für die Probe' : 'Standort';
          lines.push(`${label}: ${address}`);
        }
        if (body.deliveryDiffers) lines.push(`Lieferadresse: ${place(body.deliveryStreet, body.deliveryPostalCode, body.deliveryCity)}`);
        if (body.vatId) {
          const vatLabel = this.querySelector('[data-vat-label]');
          lines.push(`${vatLabel ? vatLabel.textContent.trim() : 'USt-IdNr.'}: ${body.vatId}`);
        }
        if (body.invoiceEmail) lines.push(`Rechnungen an: ${body.invoiceEmail}`);
        if (body.message) lines.push('', 'Nachricht:', body.message);
        lines.push('', `Gesendet über das Anfrageformular auf ${window.location.host}${body.page}`);
        return lines.join('\n');
      }

      choiceTitle() {
        const radio = this.form.querySelector('input[name="intent"]:checked');
        const title = radio ? this.form.querySelector(`label[for="${radio.id}"] .crm-anfrage__choice-title`) : null;
        if (title) return title.textContent.trim();
        return radio ? radio.value : '';
      }

      optionText(name) {
        const select = this.field(name);
        const option = select && select.selectedIndex >= 0 ? select.options[select.selectedIndex] : null;
        return option ? option.text.trim() : '';
      }
    }

    window.customElements.define('crm-anfrage', CrmAnfrage);
  }

  } catch(e) { console.error(e); }
})();
})();
